export default __webpack_public_path__ + "static/media/green_helm.53b376dc.svg";